var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-instagram';
                    var viewUrl = 'sprite.svg#view-logo-instagram';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-instagram#logo-instagram';
                            viewUrl = 'sprite.svg?logo-instagram#view-logo-instagram';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 512 512',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };